import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { savePostLoginRedirect } from '../services/postLoginRedirect';
import Unauthorized from '../containers/Unauthorized';

const mapStateToProps = (state, ownProps?) => ({
  user: state.auth.user
})

// Stash the attempted URL before bouncing to /login so the login flow can send
// the user back here afterwards. Done in an effect (not during render) so it's
// a clean side effect under StrictMode.
const RedirectToLogin = ({ location }) => {
  useEffect(() => {
    savePostLoginRedirect(location);
  }, [location]);
  return <Redirect to='/login' />;
}

// `allowedRoles` (optional): array of usertypes permitted to view the route.
// Omit to allow any logged-in user. When present and the user's role isn't in
// it, render the explicit Unauthorized page in place (URL preserved) rather
// than redirecting -- this is also what makes a role-mismatched deep link that
// survived the login round-trip land on a clear "access denied" page with no
// special handling in the restore flow.
const PrivateRoute = ({ component: Component, user, allowedRoles, ...rest}) => {
  return <Route {...rest} render={(props) => {
    if (user === null) return <RedirectToLogin location={props.location} />;
    if (allowedRoles && !allowedRoles.includes(user.usertype))
      return <Unauthorized />;
    return <Component {...props} />;
  }} />
}

export default connect(
  mapStateToProps,
)(PrivateRoute);
